var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card)?_c('div',{staticClass:"cardid"},[_c('span',[_vm._v("#"+_vm._s(_vm.card.id))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }